module.exports = __webpack_public_path__ + "static/media/corn.1dfdd620.svg";